import type { ReactNode } from 'react';
import { Lark } from './Lark';

/**
 * The frame around every signed-out screen.
 *
 * Extracted the moment there were three of them — sign in, sign up, forgot —
 * because the alternative is the same wordmark, card and spacing copied three
 * times, which is three places for them to drift apart. These are the first
 * screens anybody sees, and one of them looking slightly different from the
 * others is the kind of detail that reads as carelessness without anyone being
 * able to say why.
 */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="grid min-h-full place-items-center bg-canvas px-4 py-10">
      <div className="w-full max-w-[400px]">
        <div className="mb-7 flex items-center gap-3">
          <span className="grid size-10 place-items-center rounded-[11px] bg-accent text-white">
            <Lark width={24} />
          </span>
          <div>
            <div className="font-display text-[19px] leading-tight font-extrabold tracking-[-0.03em]">
              Crewlark
            </div>
            <div className="text-[13px] text-ink-3">Field service dispatch</div>
          </div>
        </div>

        <div className="rounded-card border border-line bg-surface p-6 shadow-[0_2px_3px_rgb(37_59_45/0.02)]">
          <h1 className="font-display text-[19px] leading-snug font-extrabold tracking-[-0.02em]">
            {title}
          </h1>
          {subtitle && <p className="mt-1 mb-5 text-[13px] leading-relaxed text-ink-3">{subtitle}</p>}
          {!subtitle && <div className="mb-5" />}
          {children}
        </div>
      </div>
    </div>
  );
}
